<template>
  <div class="logo" style="float:left">
    <h1>
      <router-link to="/">
        <img src="../../assets/images/logo.png" alt="" width="105px" height="30px">
          <span class="line">|</span>
        <span class="title">高端智能设备一站式服务平台</span>
      </router-link>
    </h1>
    <!-- <img src="../../assets/images/logo.png" alt="" width="105px" height="30px">
      &nbsp;<span class="line">|</span>
    <span class="title">高端智能设备一站式服务平台</span> -->
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        url:axios.defaults.baseURL
      }
    },
    mounted(){
      this.url =  window.location.origin;
    }
  }
</script>
<style lang="less" scoped>
  .logo{
    display: flex;
    align-items: center;
    // height: 40px;
    overflow: hidden;
    padding-left: 10px;
    a{
      color: #333;
      font-weight: normal;
      display: flex;
      // justify-items: center;
      align-items: center;
    }
  }
  .line{
    font-size: 26px;
    padding:0 18px;
  }
  .title{
    font-size: 22px;
  }
</style>






// WEBPACK FOOTER //
// src/components/logo/Logo.vue